/*
 *
 * Surveys constants
 *
 */

export const FETCH_SURVEYS = 'app/SurveysPage/FETCH_SURVEYS';
export const FETCH_SURVEYS_SUCCESS = 'app/SurveysPage/FETCH_SURVEYS_SUCCESS';
export const FETCH_SURVEYS_ERROR = 'app/SurveysPage/FETCH_SURVEYS_ERROR';
export const FETCH_FOLDER_TREE = 'app/SurveysPage/FETCH_FOLDER_TREE';
export const FETCH_FOLDER_TREE_SUCCESS =
  'app/SurveysPage/FETCH_FOLDER_TREE_SUCCESS';
export const FETCH_FOLDER_TREE_ERROR =
  'app/SurveysPage/FETCH_FOLDER_TREE_ERROR';
export const SET_SURVEY_FILTER = 'app/SurveysPage/SET_SURVEY_FILTER';
export const SHOW_SURVEY_DELETE = 'app/SurveysPage/SHOW_SURVEY_DELETE';
export const HIDE_SURVEY_DELETE = 'app/SurveysPage/HIDE_SURVEY_DELETE';
export const SHOW_SURVEY_DUPLICATE = 'app/SurveysPage/SHOW_SURVEY_DUPLICATE';
export const HIDE_SURVEY_DUPLICATE = 'app/SurveysPage/HIDE_SURVEY_DUPLICATE';
export const SHOW_SURVEY_MOVE = 'app/SurveysPage/SHOW_SURVEY_MOVE';
export const HIDE_SURVEY_MOVE = 'app/SurveysPage/HIDE_SURVEY_MOVE';
export const HIDE_SURVEY_PAUSE = 'app/SurveysPage/HIDE_SURVEY_PAUSE';
export const SHOW_SURVEY_STOP = 'app/SurveysPage/SHOW_SURVEY_STOP';
export const HIDE_SURVEY_STOP = 'app/SurveysPage/HIDE_SURVEY_STOP';
export const SHOW_SURVEY_STOP_DLINK = 'app/SurveysPage/SHOW_SURVEY_STOP_DLINK';
export const HIDE_SURVEY_STOP_DLINK = 'app/SurveysPage/HIDE_SURVEY_STOP_DLINK';
export const SURVEY_STOP = 'app/SurveysPage/SURVEY_STOP';
export const SURVEY_STOP_SUCCESS = 'app/SurveysPage/SURVEY_STOP_SUCCESS';
export const SURVEY_STOP_ERROR = 'app/SurveysPage/SURVEY_STOP_ERROR';
export const HIDE_SURVEY_RESUME = 'app/SurveysPage/HIDE_SURVEY_RESUME';
export const SHOW_SURVEY_SCHEDULING_CANCEL =
  'app/SurveysPage/SHOW_SURVEY_SCHEDULING_CANCEL';
export const HIDE_SURVEY_SCHEDULING_CANCEL =
  'app/SurveysPage/HIDE_SURVEY_SCHEDULING_CANCEL';
export const SHOW_SURVEY_SCHEDULING_ADD =
  'app/SurveysPage/SHOW_SURVEY_SCHEDULING_ADD';
export const HIDE_SURVEY_SCHEDULING_ADD =
  'app/SurveysPage/HIDE_SURVEY_SCHEDULING_ADD';
export const SURVEY_SCHEDULING_CANCEL = 'app/SurveysPage/SCHEDULING_CANCEL';
export const SURVEY_SCHEDULING_CANCEL_ERROR =
  'app/SurveysPage/SURVEY_SCHEDULING_CANCEL_ERROR';

export const SHOW_FOLDER_CREATE = 'app/SurveysPage/SHOW_FOLDER_CREATE';
export const HIDE_FOLDER_CREATE = 'app/SurveysPage/HIDE_FOLDER_CREATE';

export const CREATE_FOLDER = 'app/SurveysPage/CREATE_FOLDER';
export const CREATE_FOLDER_SUCCESS = 'app/SurveysPage/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_ERROR = 'app/SurveysPage/CREATE_FOLDER_ERROR';

export const SHOW_FOLDER_MOVE = 'app/SurveysPage/SHOW_FOLDER_MOVE';
export const HIDE_FOLDER_MOVE = 'app/SurveysPage/HIDE_FOLDER_MOVE';

export const MOVE_FOLDER = 'app/SurveysPage/MOVE_FOLDER';
export const MOVE_FOLDER_SUCCESS = 'app/SurveysPage/MOVE_FOLDER_SUCCESS';
export const MOVE_FOLDER_ERROR = 'app/SurveysPage/MOVE_FOLDER_ERROR';

export const SET_MANAGE_MODE = 'app/SurveysPage/SET_MANAGE_MODE';
export const RESET_SELECTED_ITEMS = 'app/SurveysPage/RESET_SELECTED_ITEMS';

export const SHOW_FOLDER_DELETE = 'app/SurveysPage/SHOW_FOLDER_DELETE';
export const HIDE_FOLDER_DELETE = 'app/SurveysPage/HIDE_FOLDER_DELETE';
export const DELETE_FOLDER = 'app/SurveysPage/DELETE_FOLDER';
export const DELETE_FOLDER_SUCCESS = 'app/SurveysPage/DELETE_FOLDER_SUCCESS';
export const DELETE_FOLDER_ERROR = 'app/SurveysPage/DELETE_FOLDER_ERROR';

export const SHOW_FOLDER_DUPLICATE = 'app/SurveysPage/SHOW_FOLDER_DUPLICATE';
export const HIDE_FOLDER_DUPLICATE = 'app/SurveysPage/HIDE_FOLDER_DUPLICATE';
export const DUPLICATE_FOLDER = 'app/SurveysPage/DUPLICATE_FOLDER';
export const DUPLICATE_FOLDER_SUCCESS =
  'app/SurveysPage/DUPLICATE_FOLDER_SUCCESS';
export const DUPLICATE_FOLDER_ERROR = 'app/SurveysPage/DUPLICATE_FOLDER_ERROR';

export const SHOW_FOLDER_RENAME = 'app/SurveysPage/SHOW_FOLDER_RENAME';
export const HIDE_FOLDER_RENAME = 'app/SurveysPage/HIDE_FOLDER_RENAME';
export const RENAME_FOLDER = 'app/SurveysPage/RENAME_FOLDER';
export const RENAME_FOLDER_SUCCESS = 'app/SurveysPage/RENAME_FOLDER_SUCCESS';
export const RENAME_FOLDER_ERROR = 'app/SurveysPage/RENAME_FOLDER_ERROR';

export const MOVE_MULTIPLE = 'app/SurveysPage/MOVE_MULTIPLE';
export const MOVE_MULTIPLE_SUCCESS = 'app/SurveysPage/MOVE_MULTIPLE_SUCCESS';
export const MOVE_MULTIPLE_ERROR = 'app/SurveysPage/MOVE_MULTIPLE_ERROR';
export const SHOW_MOVE_MULTIPLE = 'app/SurveysPage/SHOW_MOVE_MULTIPLE';
export const HIDE_MOVE_MULTIPLE = 'app/SurveysPage/HIDE_MOVE_MULTIPLE';

export const DUPLICATE_MULTIPLE = 'app/SurveysPage/DUPLICATE_MULTIPLE';
export const DUPLICATE_MULTIPLE_SUCCESS =
  'app/SurveysPage/DUPLICATE_MULTIPLE_SUCCESS';
export const DUPLICATE_MULTIPLE_ERROR =
  'app/SurveysPage/DUPLICATE_MULTIPLE_ERROR';
export const SHOW_DUPLICATE_MULTIPLE =
  'app/SurveysPage/SHOW_DUPLICATE_MULTIPLE';
export const HIDE_DUPLICATE_MULTIPLE =
  'app/SurveysPage/HIDE_DUPLICATE_MULTIPLE';

export const DELETE_MULTIPLE = 'app/SurveysPage/DELETE_MULTIPLE';
export const DELETE_MULTIPLE_SUCCESS =
  'app/SurveysPage/DELETE_MULTIPLE_SUCCESS';
export const DELETE_MULTIPLE_ERROR = 'app/SurveysPage/DELETE_MULTIPLE_ERROR';
export const SHOW_DELETE_MULTIPLE = 'app/SurveysPage/SHOW_DELETE_MULTIPLE';
export const HIDE_DELETE_MULTIPLE = 'app/SurveysPage/HIDE_DELETE_MULTIPLE';

export const FETCH_FOLDER_STATS = 'app/SurveysPage/FETCH_FOLDER_STATS';
export const FETCH_FOLDER_STATS_SUCCESS =
  'app/SurveysPage/FETCH_FOLDER_STATS_SUCCESS';
export const FETCH_FOLDER_STATS_ERROR =
  'app/SurveysPage/FETCH_FOLDER_STATS_ERROR';

export const SHOW_WITHDRAW_SURVEY_APPROVAL =
  'app/SurveysPage/SHOW_WITHDRAW_SURVEY_APPROVAL';
export const HIDE_WITHDRAW_SURVEY_APPROVAL =
  'app/SurveysPage/HIDE_WITHDRAW_SURVEY_APPROVAL';
export const WITHDRAW_SURVEY_APPROVAL =
  'app/SurveysPage/WITHDRAW_SURVEY_APPROVAL';
export const WITHDRAW_SURVEY_APPROVAL_SUCCESS =
  'app/SurveysPage/WITHDRAW_SURVEY_APPROVAL_SUCCESS';
export const WITHDRAW_SURVEY_APPROVAL_ERROR =
  'app/SurveysPage/WITHDRAW_SURVEY_APPROVAL_ERROR';

export const SHOW_CONFIRMATION_VISUALIZE_DATA =
  'app/SurveysPage/SHOW_CONFIRMATION_VISUALIZE_DATA';
export const HIDE_CONFIRMATION_VISUALIZE_DATA =
  'app/SurveysPage/HIDE_CONFIRMATION_VISUALIZE_DATA';
export const SHOW_CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST =
  'app/SurveysPage/SHOW_CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST';
export const HIDE_CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST =
  'app/SurveysPage/HIDE_CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST';
export const VISUALIZE_DATA = 'app/SurveysPage/VISUALIZE_DATA';
export const VISUALIZE_DATA_SUCCESS = 'app/SurveysPage/VISUALIZE_DATA_SUCCESS';
export const VISUALIZE_DATA_ERROR = 'app/SurveysPage/VISUALIZE_DATA_ERROR';
export const FETCH_SURVEYS_HAS_VISUALIZE_DATA =
  'app/SurveysPage/FETCH_SURVEYS_HAS_VISUALIZE_DATA';
export const FETCH_SURVEYS_HAS_VISUALIZE_DATA_SUCCESS =
  'app/SurveysPage/FETCH_SURVEYS_HAS_VISUALIZE_DATA_SUCCESS';
export const FETCH_SURVEYS_HAS_VISUALIZE_DATA_ERROR =
  'app/SurveysPage/FETCH_SURVEYS_HAS_VISUALIZE_DATA_ERROR';

export const CONVERT_TO_REGULAR = 'app/SurveysPage/CONVERT_TO_REGULAR';
export const CONVERT_TO_REGULAR_SUCCESS =
  'app/SurveysPage/CONVERT_TO_REGULAR_SUCCESS';
export const CONVERT_TO_REGULAR_ERROR =
  'app/SurveysPage/CONVERT_TO_REGULAR_ERROR';

export const CONVERT_TO_DISTRIBUTION_LINK =
  'app/SurveysPage/CONVERT_TO_DISTRIBUTION_LINK';
export const CONVERT_TO_DISTRIBUTION_LINK_SUCCESS =
  'app/SurveysPage/CONVERT_TO_DISTRIBUTION_LINK_SUCCESS';
export const CONVERT_TO_DISTRIBUTION_LINK_ERROR =
  'app/SurveysPage/CONVERT_TO_DISTRIBUTION_LINK_ERROR';

export const SHOW_PAUSE_EDIT_SURVEY_PEEQ =
  'app/SurveysPage/SHOW_PAUSE_EDIT_SURVEY_PEEQ';
export const SHOW_PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED =
  'app/SurveysPage/SHOW_PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED';
export const SHOW_PAUSE_EDIT_SURVEY_DLINK_SIMPLIFIED =
  'app/SurveysPage/SHOW_PAUSE_EDIT_SURVEY_DLINK_SIMPLIFIED';
export const HIDE_PAUSE_EDIT_SURVEY = 'app/SurveysPage/HIDE_PAUSE_EDIT_SURVEY';
export const PAUSE_EDIT_SURVEY = 'app/SurveysPage/PAUSE_EDIT_SURVEY';
export const PAUSE_EDIT_SURVEY_SUCCESS =
  'app/SurveysPage/PAUSE_EDIT_SURVEY_SUCCESS';
export const PAUSE_EDIT_SURVEY_ERROR =
  'app/SurveysPage/PAUSE_EDIT_SURVEY_ERROR';
export const SHOW_PAUSE_EDIT_SURVEY_PEEQ_SCHEDULED =
  'app/SurveysPage/SHOW_PAUSE_EDIT_SURVEY_PEEQ_SCHEDULED';
export const HIDE_PAUSE_EDIT_SURVEY_PEEQ_SCHEDULED =
  'app/SurveysPage/HIDE_PAUSE_EDIT_SURVEY_PEEQ_SCHEDULED';
export const CANCEL_SCHEDULING_FOR_EDIT_PEEQ =
  'app/SurveysPage/CANCEL_SCHEDULING_FOR_EDIT_PEEQ';

export const SHOW_RESUME_SURVEY_DISTRIBUTION =
  'app/SurveysPage/SHOW_RESUME_SURVEY_DISTRIBUTION';
export const HIDE_RESUME_SURVEY_DISTRIBUTION =
  'app/SurveysPage/HIDE_RESUME_SURVEY_DISTRIBUTION';
export const RESUME_SURVEY_DISTRIBUTION =
  'app/SurveysPage/RESUME_SURVEY_DISTRIBUTION';
export const RESUME_SURVEY_DISTRIBUTION_SUCCESS =
  'app/SurveysPage/RESUME_SURVEY_DISTRIBUTION_SUCCESS';
export const RESUME_SURVEY_DISTRIBUTION_ERROR =
  'app/SurveysPage/RESUME_SURVEY_DISTRIBUTION_ERROR';
export const SHOW_PAUSE_SURVEY_DISTRIBUTION =
  'app/SurveysPage/SHOW_PAUSE_SURVEY_DISTRIBUTION';
export const HIDE_PAUSE_SURVEY_DISTRIBUTION =
  'app/SurveysPage/HIDE_PAUSE_SURVEY_DISTRIBUTION';
export const PAUSE_SURVEY_DISTRIBUTION =
  'app/SurveysPage/PAUSE_SURVEY_DISTRIBUTION';
export const PAUSE_SURVEY_DISTRIBUTION_SUCCESS =
  'app/SurveysPage/PAUSE_SURVEY_DISTRIBUTION_SUCCESS';
export const PAUSE_SURVEY_DISTRIBUTION_ERROR =
  'app/SurveysPage/PAUSE_SURVEY_DISTRIBUTION_ERROR';
export const SHOW_RELAUNCH_SURVEY_DLINK =
  'app/SurveysPage/SHOW_RELAUNCH_SURVEY_DLINK';
export const HIDE_RELAUNCH_SURVEY_DLINK =
  'app/SurveysPage/HIDE_RELAUNCH_SURVEY_DLINK';
export const RELAUNCH_SURVEY_DLINK = 'app/SurveysPage/RELAUNCH_SURVEY_DLINK';
export const RELAUNCH_SURVEY_DLINK_SUCCESS =
  'app/SurveysPage/RELAUNCH_SURVEY_DLINK_SUCCESS';
export const RELAUNCH_SURVEY_DLINK_ERROR =
  'app/SurveysPage/RELAUNCH_SURVEY_DLINK_ERROR';
export const SHOW_RENAME_SURVEY = 'app/SurveysPage/SHOW_RENAME_SURVEY';
export const HIDE_RENAME_SURVEY = 'app/SurveysPage/HIDE_RENAME_SURVEY';
export const RENAME_SURVEY = 'app/SurveysPage/RENAME_SURVEY';
export const RENAME_SURVEY_SUCCESS = 'app/SurveysPage/RENAME_SURVEY_SUCCESS';
export const RENAME_SURVEY_ERROR = 'app/SurveysPage/RENAME_SURVEY_ERROR';

export const SHOW_PAUSE_SURVEY_PEEQ = 'app/SurveysPage/SHOW_PAUSE_SURVEY_PEEQ';
export const HIDE_PAUSE_SURVEY_PEEQ = 'app/SurveysPage/HIDE_PAUSE_SURVEY_PEEQ';
export const PAUSE_SURVEY_PEEQ = 'app/SurveysPage/PAUSE_SURVEY_PEEQ';
export const PAUSE_SURVEY_PEEQ_SUCCESS =
  'app/SurveysPage/PAUSE_SURVEY_PEEQ_SUCCESS';
export const PAUSE_SURVEY_PEEQ_ERROR =
  'app/SurveysPage/PAUSE_SURVEY_PEEQ_ERROR';

export const PAUSE_EDIT_SURVEY_PEEQ = 'app/SurveysPage/PAUSE_EDIT_SURVEY_PEEQ';
export const PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED =
  'app/SurveysPage/PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED';
export const PAUSE_EDIT_SURVEY_PEEQ_SUCCESS =
  'app/SurveysPage/PAUSE_EDIT_SURVEY_PEEQ_SUCCESS';
export const PAUSE_EDIT_SURVEY_PEEQ_ERROR =
  'app/SurveysPage/PAUSE_EDIT_SURVEY_PEEQ_ERROR';

export const SHOW_RESUME_SURVEY_PEEQ =
  'app/SurveysPage/SHOW_RESUME_SURVEY_PEEQ';
export const HIDE_RESUME_SURVEY_PEEQ =
  'app/SurveysPage/HIDE_RESUME_SURVEY_PEEQ';
export const RESUME_SURVEY_PEEQ = 'app/SurveysPage/RESUME_SURVEY_PEEQ';
export const RESUME_SURVEY_PEEQ_SUCCESS =
  'app/SurveysPage/RESUME_SURVEY_PEEQ_SUCCESS';
export const RESUME_SURVEY_PEEQ_ERROR =
  'app/SurveysPage/RESUME_SURVEY_PEEQ_ERROR';

export const SHOW_STOP_SURVEY_PEEQ = 'app/SurveysPage/SHOW_STOP_SURVEY_PEEQ';
export const HIDE_STOP_SURVEY_PEEQ = 'app/SurveysPage/HIDE_STOP_SURVEY_PEEQ';
export const STOP_SURVEY_PEEQ = 'app/SurveysPage/STOP_SURVEY_PEEQ';
export const STOP_SURVEY_PEEQ_SUCCESS =
  'app/SurveysPage/STOP_SURVEY_PEEQ_SUCCESS';
export const STOP_SURVEY_PEEQ_ERROR = 'app/SurveysPage/STOP_SURVEY_PEEQ_ERROR';

export const SHOW_ACCEPT_NEW_CPI_RESTART =
  'app/SurveysPage/SHOW_ACCEPT_NEW_CPI_RESTART';
export const HIDE_ACCEPT_NEW_CPI_RESTART =
  'app/SurveysPage/HIDE_ACCEPT_NEW_CPI_RESTART';
export const ACCEPT_NEW_CPI_RESTART = 'app/SurveysPage/ACCEPT_NEW_CPI_RESTART';
export const ACCEPT_NEW_CPI_RESTART_SUCCESS =
  'app/SurveysPage/ACCEPT_NEW_CPI_RESTART_SUCCESS';
export const ACCEPT_NEW_CPI_RESTART_ERROR =
  'app/SurveysPage/ACCEPT_NEW_CPI_RESTART_ERROR';

export const SET_CREATE_SURVEY_MODAL =
  'app/SurveysPage/SET_CREATE_SURVEY_MODAL';

export const SHOW_EDIT_SURVEY_ADL = 'app/SurveysPage/SHOW_EDIT_SURVEY_ADL';
export const HIDE_EDIT_SURVEY_ADL = 'app/SurveysPage/HIDE_EDIT_SURVEY_ADL';
export const SHOW_EDIT_SURVEY_DLINK = 'app/SurveysPage/SHOW_EDIT_SURVEY_DLINK';
export const HIDE_EDIT_SURVEY_DLINK = 'app/SurveysPage/HIDE_EDIT_SURVEY_DLINK';
export const DISCARD_DLINK_REVISION = 'app/SurveysPage/DISCARD_DLINK_REVISION';
export const CLEAR_DLINK_REVISION = 'app/SurveysPage/CLEAR_DLINK_REVISION';
export const SHOW_EDIT_SURVEY_QUOTA = 'app/SurveysPage/SHOW_EDIT_SURVEY_QUOTA';
export const HIDE_EDIT_SURVEY_QUOTA = 'app/SurveysPage/HIDE_EDIT_SURVEY_QUOTA';
export const SHOW_NOTIFICATION_FOR_DUPLICATE_REGULAR_TO_PREPAID =
  'app/SurveysPage/SHOW_NOTIFICATION_FOR_DUPLICATE_REGULAR_TO_PREPAID';
export const HIDE_NOTIFICATION_FOR_DUPLICATE_REGULAR_TO_PREPAID =
  'app/SurveysPage/HIDE_NOTIFICATION_FOR_DUPLICATE_REGULAR_TO_PREPAID';

export const modalActions = {
  CREATE_FOLDER: 'CREATE_FOLDER',
  RENAME_FOLDER: 'RENAME_FOLDER',
  DELETE_FOLDER: 'DELETE_FOLDER',
  DUPLICATE_FOLDER: 'DUPLICATE_FOLDER',
  MOVE_FOLDER: 'MOVE_FOLDER',
  MOVE_MULTIPLE: 'MOVE_MULTIPLE',
  DELETE_MULTIPLE: 'DELETE_MULTIPLE',
  DUPLICATE_MULTIPLE: 'DUPLICATE_MULTIPLE',
  DELETE_SURVEY: 'DELETE_SURVEY',
  PAUSE_SURVEY_PEEQ: 'PAUSE_SURVEY_PEEQ',
  RESUME_SURVEY_PEEQ: 'RESUME_SURVEY_PEEQ',
  STOP_SURVEY: 'STOP_SURVEY',
  STOP_SURVEY_DLINK: 'STOP_SURVEY_DLINK',
  STOP_SURVEY_PEEQ: 'STOP_SURVEY_PEEQ',
  DUPLICATE_SURVEY: 'DUPLICATE_SURVEY',
  MOVE_SURVEY: 'MOVE_SURVEY',
  WITHDRAW_SURVEY_APPROVAL: 'WITHDRAW_SURVEY_APPROVAL',
  ADD_SURVEY_SCHEDULING: 'ADD_SURVEY_SCHEDULING',
  PAUSE_EDIT_SURVEY_PEEQ: 'PAUSE_EDIT_SURVEY_PEEQ',
  PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED: 'PAUSE_EDIT_SURVEY_PEEQ_SIMPLIFIED',
  PAUSE_EDIT_SURVEY_DLINK_SIMPLIFIED: 'PAUSE_EDIT_SURVEY_DLINK_SIMPLIFIED',
  RENAME_SURVEY: 'RENAME_SURVEY',
  ADD_MORE_RESPONSES: 'ADD_MORE_RESPONSES',
  CANCEL_SCHEDULING: 'CANCEL_SCHEDULING',
  RESUME_SURVEY_DISTRIBUTION: 'RESUME_SURVEY_DISTRIBUTION',
  PAUSE_SURVEY_DISTRIBUTION: 'PAUSE_SURVEY_DISTRIBUTION',
  RELAUNCH_SURVEY_DLINK: 'RELAUNCH_SURVEY_DLINK',
  CONFIRMATION_VISUALIZE_DATA: 'CONFIRMATION_VISUALIZE_DATA',
  CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST:
    'CONFIRMATION_VISUALIZE_DATA_DEMO_REQUEST',
  VISUALIZE_DATA: 'VISUALIZE_DATA',
  ACCEPT_NEW_CPI_RESTART: 'ACCEPT_NEW_CPI_RESTART',
  EDIT_SURVEY_ADL: 'EDIT_SURVEY_ADL',
  EDIT_SURVEY_DLINK: 'EDIT_SURVEY_DLINK',
  EDIT_SURVEY_QUOTA: 'EDIT_SURVEY_QUOTA',
};
export const sortByEnum = {
  TIME_CREATED: 'timeCreated',
  NAME: 'name',
};
export const sortOrderEnum = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};
export const surveyStatusEnum = {
  ALL: 'all',
  PAUSED: 'paused',
  PAUSED_REVIEW_CPI: 'pausedReviewCpi',
  PAUSED_UNDER_COMPLETION: 'pausedUnderCompletion',
  PAUSED_UNDER_PROBATION: 'pausedUnderProbation',
  PAUSED_QUOTAS_FILLING_UP: 'pausedQuotasFillingUp',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  FAILED_TO_START: 'failedToStart',
  DRAFT: 'draft',
  RUNNING: 'running',
  UNDER_APPROVAL: 'underApproval',
  UNDER_APPROVAL_LOCK: 'underApprovalLock',
  APPROVED: 'approved',
  UNDER_EDIT: 'underEdit',
  PENDING_TO_START: 'pendingToStart',
  PENDING_COMPLETE: 'pendingComplete',
  INVOICED: 'invoiced',
  UNDER_PROBATION: 'underProbation',
  UNKNOWN: 'unknown',
};

export const surveyTypeEnum = {
  ALL: [0, 4, 6, 8, 9],
  THIRD_PARTY: 6,
  INTERNAL: 4,
  DISTRIBUTION_LINK: 8,
  PEEQ: [0, 9],
  NONE: [],
};

export const manageModeSelectStateEnum = {
  INTERMEDIATE_STATE: 0,
  ALL_CHECKED: 1,
  NONE_CHECKED: 2,
};

export const chargeNowStatusList = [
  surveyStatusEnum.APPROVED,
  surveyStatusEnum.RUNNING,
  surveyStatusEnum.COMPLETED,
  surveyStatusEnum.UNDER_EDIT,
];

export const SURVEY_STATUS_ALLOWED_COUNT_LIST = [
  surveyStatusEnum.APPROVED,
  surveyStatusEnum.UNDER_EDIT,
  surveyStatusEnum.UNDER_APPROVAL,
  surveyStatusEnum.PAUSED,
  surveyStatusEnum.RUNNING,
];

export const SURVEY_SEARCH_MOBILE_CONTAINER_ID = 'survey-search-mobile';
export const BREADCRUMB_FOLDERS_MOBILE_ID = 'mobile-breadcrumb-folder';
export const BREADCRUMB_BTN_CONTAINER_MOBILE_ID =
  'breadcrumb-btn-container-mobile';
